<template>
    <div class="info">
        <div class="user-basic">
          <div class="um">
            <!--<img :src="member.portrait ? member.portrait : (member.gender === 1 ? defaultAvatar2 : defaultAvatar)" :onerror="`this.src='${member.gender === 1 ? defaultAvatar2 : defaultAvatar}'`" class="avatar" v-if="member.loginName">-->
            <img :src="uf.portrait ? uf.portrait : (uf.gender === 1 ? defaultAvatar2 : defaultAvatar)" :onerror="`this.src='${uf.gender === 1 ? defaultAvatar2 : defaultAvatar}'`" class="avatar" v-if="uf.name">
            <div class="uinfo">
              <p class="name">
                <!--<span title="">{{member.loginName | truncate(10)}}</span>-->
                <span title="">{{uf.name | truncate(10)}}</span>
                <img src="~@/assets/images/icons/vip/huangguan.png" style="position: relative;top:2px;" class="vip-icon" v-if="!_.isEmpty(vip) && vip.level === 4">
                <img src="~@/assets/images/icons/vip/zuanshi.png" style="position: relative;top:1px;" class="vip-icon" v-else-if="!_.isEmpty(vip) && vip.level === 3">
                <img src="~@/assets/images/icons/vip/jinka.png" style="position: relative;top:3px;" class="vip-icon" v-else-if="!_.isEmpty(vip) && vip.level === 2">
                <img src="~@/assets/images/icons/vip/yinka.png" style="position: relative;top:3px;" class="vip-icon" v-else-if="!_.isEmpty(vip) && vip.level === 1">
              </p>
              <p class="vip-info">
                <span class="expire" v-if="!_.isEmpty(vip) && vip.balance > 0">您有{{vip.balance > 99 ?  `99+` : vip.balance}}积点 将于{{vip.vipExpiryTime | dataFormat('dateTime.short4')}}到期</span>
                <span class="expire" v-else-if="!_.isEmpty(member)">最后登录时间: {{member.lastLoginTime | dataFormat('dateTime.f1')}}</span>
              </p>
            </div>
          </div>
          <div class="actions" :style="isCompany ? 'padding-left:18px;' : ''">
            <Row :gutter="0">
              <Col span="2" v-if="!isCompany">&nbsp;</Col>
              <Col span="5"><span class="invoice"><router-link class="line2" :to="{name: 'MyInvoice'}">我的发票</router-link></span></Col>
              <Col span="5"><span class="exchange"><router-link class="line2" :to="{name: 'MyIntegral'}">我的兑换</router-link></span></Col>
              <Col span="5" v-if="isCompany"><span class="coo"><router-link class="line2" :to="{name: 'RulesDecide'}">原产地预判定</router-link></span></Col>
              <Col :span="isCompany ? 4 : 7"><span class="my-integral"><span class="title">我的积点：</span><span class="value">{{stat.balance || 0}}</span></span></Col>
              <Col span="5"><div class="go-charge" @click.prevent="$router.push({name: 'Recharge'})">去充值</div></Col>
            </Row>
          </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import defaultAvatar from '@/assets/images/default_avatar.png'
import defaultAvatar2 from '@/assets/images/default_avatar2.png'
const { mapState: mapAccountState } = createNamespacedHelpers('account')

export default {
  name: 'MyAccountBasicInfoZH',
  props: {
    userInfo: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    return {
      defaultAvatar: defaultAvatar,
      defaultAvatar2: defaultAvatar2
    }
  },
  computed: {
    member () {
      return this.userInfo.member || {}
    },
    vip () {
      return this.userInfo.vip || {}
    },
    stat () {
      return this.userInfo.statistics || { today: {} }
    },
    isCompany () {
      // return this.userInfo.member && this.userInfo.member.enterprise && this.userInfo.member.enterprise.name
      return false
    },
    ...mapAccountState({
      uf: state => state.userInfo
    })
  }
}
</script>
<style scoped>
  .info{
    margin: 25px 0;
    background: #FBFBFB;
    border-radius: 5px;
  }
  .user-basic{
    padding-left: 285px;
    position: relative;
    height: 140px;
  }
  .user-basic .um{
    position: absolute;
    top: 35px;
    left: 15px;
    bottom: 35px;
    width: 280px;
    padding-left: 80px;
  }
  .user-basic .um .avatar{
    border-radius: 100%;
    width: 70px;
    height: 70px;
    position: absolute;
    top:0;
    left:0;
  }
  .user-basic .um .uinfo{
    display: flex;
    flex-direction: column;
    height: 70px;
    justify-content: center;
  }
  .user-basic .um .uinfo .name{
    font-size: 22px;
    color: #333;
    margin-bottom: 5px;
  }
  .user-basic .um .uinfo .vip-icon{
    height: 20px;
    display: inline;
    padding-left: 8px;
  }
  .user-basic .um .uinfo .vip-info{
    font-size: 12px;
    color: #B2B2B2;
  }
  .user-basic .actions >>> .ivu-col{
    display: flex;
    flex-direction: column;
    height: 140px;
    justify-content: center;
    font-size: 13px;
  }
  .actions .invoice,
  .actions .exchange,
  .actions .coo{
    background: url("~@/assets/images/icons/member/invoice.png") no-repeat 0 center transparent;
    background-size: 15px auto;
    padding-left: 22px;
    font-size: 13px;
  }
  .actions .invoice a,
  .actions .exchange a,
  .actions .coo a{
    color: #333;
  }
  .actions .invoice span{
    color: #999;
  }
  .actions .exchange{
    background-image: url("~@/assets/images/icons/member/integral.png");
    background-size: 13px auto;
    padding-left: 20px;
  }
  .actions .coo{
    background-image: url("~@/assets/images/coo/icon_wdpd.png");
  }
  .actions .my-integral{
    color: #333;
    font-size: 13px;
  }
  .actions .my-integral .title{
    position: relative;
    top: -2.6px;
    padding-right: 5px;
}
  .actions .my-integral .value{
    font-size: 20px;
    color: #1F8AFD;
  }
  .actions .go-charge{
    width: 85px;
    height: 32px;
    line-height: 32px;
    background-image: linear-gradient(90deg, #42BEFF 9%, #1F8AFD 100%);
    border-radius: 3px;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/BasicInfo.vue